module.exports = __webpack_public_path__ + "img/ic_refresh.0ac16452.svg";